import {
    GET_PRE_REGISTRATION_CONFIGURATIONS_FAIL,
    GET_PRE_REGISTRATION_CONFIGURATIONS_SUCCESS,
    ADD_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
    ADD_PRE_REGISTRATION_CONFIGURATION_FAIL,
    UPDATE_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
    UPDATE_PRE_REGISTRATION_CONFIGURATION_FAIL,
    DELETE_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
    DELETE_PRE_REGISTRATION_CONFIGURATION_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    preRegistrationConfigurations: [],
    error: null,
    loading: true
};

const preRegistrationConfigurationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des preRegistrationConfigurations
        case GET_PRE_REGISTRATION_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                preRegistrationConfigurations: action.payload, // tableau d'objets preRegistrationConfiguration
                loading: false,
                error: null
            };

        case GET_PRE_REGISTRATION_CONFIGURATIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une preRegistrationConfiguratione
        case ADD_PRE_REGISTRATION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                preRegistrationConfigurations: [action.payload, ...state.preRegistrationConfigurations], // ajoute au début du tableau
                error: null
            };

        case ADD_PRE_REGISTRATION_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une preRegistrationConfiguratione
        case UPDATE_PRE_REGISTRATION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                preRegistrationConfigurations: state.preRegistrationConfigurations.map(preRegistrationConfiguration =>
                    preRegistrationConfiguration.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet preRegistrationConfiguration
                        : preRegistrationConfiguration
                ),
                error: null
            };

        case UPDATE_PRE_REGISTRATION_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une preRegistrationConfiguratione
        case DELETE_PRE_REGISTRATION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                preRegistrationConfigurations: state.preRegistrationConfigurations.filter(
                    preRegistrationConfiguration => preRegistrationConfiguration.id !== action.payload
                ),
                error: null
            };


        case DELETE_PRE_REGISTRATION_CONFIGURATION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default preRegistrationConfigurationReducer;
